export const formatDateDMY = (dateString: string) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0"); // Pad single digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Pad single digit month
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };
  